export const LOADING_STATE = {
  LOADING: "LOADING",
  READY: "READY",
  FAILED: "FAILED"
};

export const WORDS = {
  LOAD_REQUEST: "LOAD_REQUEST",
  LOAD_SUCCESS: "LOAD_SUCCESS",
  LOAD_FAILED: "LOAD_FAILED"
};

export const GAME = {
  START: "START_GAME",
  STOP: "STOP_GAME",
  GUESS: "GUESS",
  GUESS_SUCCESS: "GUESS_SUCCESS",
  GUESS_FAILED: "GUESS_FAILED",
  GOTO_NEXT_WORD: "GOTO_NEXT_WORD"
};



// WEBPACK FOOTER //
// ./src/actionTypes.js